var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSynapsy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 524.5 149.7",
    style: {
      enableBackground: "new 0 0 524.5 149.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#221B48;}\r\n\t.st1{fill:#40BFEF;}\r\n\t.st2{fill:#F8AF00;}\r\n\t.st3{fill:#EB5F78;}\r\n\t.st4{fill:#3EB397;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185.7,105.9V95.1c4.6,2.3,10.8,4.4,17.2,4.6c2.3,0,4.6-0.2,6.5-0.7c4.6-1.1,7.4-3.3,7.4-6.8 c0-5-3.7-7.7-13.5-11.2c-11.8-4.1-18.1-9.1-18.1-19.4c0-11.1,9.4-17.8,22.5-17.8c6.5,0,12.6,1.6,16.5,3.2v10.4 c-3.7-2-9.9-3.8-15.7-3.8c-7.4,0-12.3,3-12.3,7.8c0,4.5,3.4,7.5,13.3,11c11.8,4.3,18.3,9.2,18.3,19.3c0,11.1-8.6,17.8-23,17.8 C197.1,109.5,190.2,107.7,185.7,105.9L185.7,105.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M229.1,118.7c0.9,0.3,2.7,0.7,5.1,0.7c6.5,0,9.8-4.8,12.7-11.4l-18.5-43.7h11.9l5.7,15.6 c2.2,5.9,4.5,11.9,6.5,17.8c1.6-3.7,4.8-13.4,6.5-17.8l5.6-15.6h11.9L259,107.2c-5.1,12.5-10.7,19.5-19.4,21.2 c-1.9,0.3-3.7,0.4-5.5,0.3c-2.1,0-4.1-0.4-5-0.7L229.1,118.7L229.1,118.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M291.9,64.3l0.3,5.6c0,1.7-0.4,2.8-0.4,3.2h0.2c1.8-4.1,7.7-9.9,16.2-9.9c10.6,0,15.5,6.2,15.5,17.6v27.5 h-10.9V82.6c0-5.1-1.2-9.7-7.4-9.7c-7.4,0-12.7,5.8-12.7,13.6v21.8h-10.9v-44H291.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M377.7,108.3h-10l-0.2-4.6c-0.1-1.9,0.2-3.1,0.2-3.1h-0.2c-2.1,4.7-8.2,8.8-15.3,8.8 c-11.6,0-20.7-9.1-20.7-23.1s9.1-23.1,20.7-23.1c6.9,0,13.2,4,15.3,8.4h0.2c0,0-0.3-1.2-0.2-3.1l0.2-4.1h10V108.3z M341.9,86.3 c0,8.2,5,14,12.3,14c6,0,12.4-4.5,12.4-14s-6.4-14-12.4-14C346.9,72.3,341.9,78.1,341.9,86.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M390.4,64.3h10l0.2,4.1c0.1,1.9-0.3,3.1-0.2,3.1h0.2c2.1-4.4,8.2-8.4,15.1-8.4c11.7,0,20.9,9.1,20.9,23.1 s-9.1,23.1-20.6,23.1c-6.9,0-12.5-3.6-14.8-7.7H401c0,0,0.3,1.2,0.3,3.6v22.3h-10.9V64.3L390.4,64.3z M426.2,86.3 c0-8.2-5-14-12.3-14c-6,0-12.4,4.5-12.4,14s6.4,14,12.4,14C421.2,100.3,426.2,94.6,426.2,86.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M456.1,90.2c-8.2-2.5-13.9-5.8-13.9-14.1c0-7.7,6.6-12.9,16.6-12.9c5.6,0,10.7,1.4,13.5,2.6v9.4 c-3-1.6-7.5-3-11.6-3.2c-1.5,0-3,0.1-4.4,0.4c-2.2,0.6-4.1,1.9-4.1,4.1c0,2.8,2.7,4.3,8.2,5.9c9.8,3,14.6,6.4,14.6,14.1 c0,8.3-6.9,12.9-17.4,12.9c-6.4,0-11.6-1.4-15-2.9V97c4.3,2.2,10.4,3.9,14.7,3.9c3.9,0,7.6-1.2,7.6-4.6 C465,93.2,461.9,92,456.1,90.2L456.1,90.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M477.1,118.7c0.9,0.3,2.7,0.7,5.1,0.7c6.5,0,9.8-4.8,12.7-11.4l-18.5-43.7h11.9l5.7,15.6 c2.2,5.9,4.5,11.9,6.5,17.8c1.6-3.7,4.8-13.4,6.5-17.8l5.6-15.6h11.9L507,107.2c-5.1,12.5-10.7,19.5-19.4,21.2 c-1.9,0.3-3.7,0.4-5.5,0.3c-2.2,0-4.1-0.4-5-0.7L477.1,118.7L477.1,118.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.9,146.3L16.4,96.8l13.5-13.3L75.3,128l22.6-22.2l13.5,13.3l-27.8,27.2C79.1,150.8,71.5,150.8,66.9,146.3 L66.9,146.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.5,108.5L30.9,66.7l-22.5,22l-4.8-4.8c-4.8-4.7-4.8-12.4,0-17.1l27.3-26.7l56.2,55L73.5,108.5L73.5,108.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M120.5,109.8L61.7,52.2l13.5-13.3l45.2,44.3L143,61.1l4.8,4.8c4.8,4.7,4.8,12.4,0,17.1L120.5,109.8 L120.5,109.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M118.6,63.6L75.9,21.8l-23,22.5L39.4,31L67.6,3.4c4.6-4.5,12.2-4.5,16.8,0l47.8,46.8L118.6,63.6L118.6,63.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSynapsy);
export default __webpack_public_path__ + "static/media/synapsy.635538e92201486867d82b53055f55bc.svg";
export { ForwardRef as ReactComponent };